// extracted by mini-css-extract-plugin
export default {"imageContainer":"OrderProductImage_imageContainer__PHceV"};